import { render, staticRenderFns } from "./RoleStylePanel.vue?vue&type=template&id=67881ee4&scoped=true"
import script from "./RoleStylePanel.vue?vue&type=script&lang=js"
export * from "./RoleStylePanel.vue?vue&type=script&lang=js"
import style0 from "./RoleStylePanel.vue?vue&type=style&index=0&id=67881ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67881ee4",
  null
  
)

export default component.exports